import { useState } from 'react';

export default function CtaFollow() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setDone(true);
  };

  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-6 md:px-6">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500 px-5 py-7 md:px-8 md:py-9">
        <div className="absolute -right-6 -top-8 h-36 w-36 rounded-full bg-background-50/10" />
        <div className="absolute right-16 -bottom-10 h-28 w-28 rounded-full bg-background-50/10" />
        <div className="relative flex flex-col items-start gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <span className="flex items-center gap-1.5 text-[12px] font-bold uppercase tracking-wider text-background-50/80">
              <i className="ri-notification-4-line text-[14px]"></i> 新鲜黑料 · 即时通知
            </span>
            <h2 className="mt-2 font-heading text-2xl leading-tight text-background-50 md:text-3xl">
              别错过今日曝光主角的第一条新料
            </h2>
            <p className="mt-2 text-[13px] leading-relaxed text-background-50/90">
              登记邮箱，刚刚流出的新鲜黑料与今日新料汇总一到站，第一时间推送给你，追踪最新黑料今日曝光不迷路。
            </p>
          </div>

          {done ? (
            <div className="flex shrink-0 items-center gap-2.5 rounded-xl bg-background-50/95 px-5 py-3.5 text-primary-700">
              <i className="ri-checkbox-circle-fill text-xl text-primary-500"></i>
              <div>
                <p className="text-[13px] font-bold">订阅成功</p>
                <p className="text-[11px]">新料推送已就位</p>
              </div>
            </div>
          ) : (
            <form onSubmit={submit} className="flex w-full max-w-md shrink-0 flex-col gap-2 sm:flex-row sm:items-center">
              <div className="flex min-w-0 flex-1 items-center gap-2 rounded-lg bg-background-50/95 px-3 py-2">
                <i className="ri-mail-line text-sm text-foreground-400"></i>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱，接收新料推送"
                  className="min-w-0 flex-1 bg-transparent text-[13px] text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>
              <button
                type="submit"
                className="shrink-0 whitespace-nowrap rounded-lg bg-secondary-900 px-5 py-2 text-[13px] font-medium text-background-50 transition-colors hover:bg-secondary-950"
              >
                开启追更
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}